import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

/**
 * Controls css styling for this component using js to css
 */
let css = {
  title: {
    color: "#343a40",
    fontWeight: 500,
    fontSize: 28,
    letterSpacing: "0rem",
    padding: "0px 12px",
  }
};

/**
 * Component that displays target body name in console.
 * Retrieves target name from target selector
 *
 * @component
 * @example
 * const target = Mars
 * return (
 *   <ConsoleTargetInfo target={target}/>
 * )
 */
export default function ConsoleTargetInfo(props) {
  return (
    <Grid
      container
      item
      justifyContent="center"
      alignItems="center"
      xs
    >
        <Typography id="targetName" sx={css.title} variant="h4">
          {props.target.toUpperCase()} {(props.feature == "") ? "" : " – " + props.feature}
        </Typography>
    </Grid>
  );
}
